import { useMemo } from 'react';

import { EMPTY_ID } from '@e-socna/empty-client';

import { useAuthenticationContext } from '../contexts/AuthenticationContext/hooks/useAuthenticationContext.hook';

export const useTrackableData = () => {
  const { authenticationData } = useAuthenticationContext();

  const trackableData = useMemo(() => {
    const now = new Date().toISOString();

    return {
      createdAt: now,
      creatorId: authenticationData?._id ?? EMPTY_ID,
      updatedAt: now,
      updaterId: authenticationData?._id ?? EMPTY_ID,
    };
  }, [authenticationData?._id]);

  return { trackableData };
};
